export default __webpack_public_path__ + "static/media/Welcome-gif-2.c1f687c6.png";